
<div id="app">
  <RouterView />
</div>
